import { BeneficiaryInsightWidgetDTO } from '@repo/shared/dtos/beneficiary'

export function getWidgetDefaultSize(type: BeneficiaryInsightWidgetDTO['type']) {
  return {
    kpi: { width: 2, height: 1 },
    pie: { width: 4, height: 2 },
    bar: { width: 6, height: 3 },
    line: { width: 6, height: 3 },
  }[type]
}
